import { useNavigationLinks } from 'hooks/useNavigationLinks';

import { LinkGroup } from './LinkGroup.styled';
import { FooterLink } from './FooterLink';

import type { FC } from 'react';
import type { LinkGroup as LinkGroupProp, MenuLink } from 'hooks/useNavigationLinks/types';

interface FooterLinksProps {
  linkGroup: LinkGroupProp;
}

export const FooterLinks: FC<FooterLinksProps> = ({ linkGroup }) => {
  const links: MenuLink[] = useNavigationLinks(linkGroup);

  return (
    <LinkGroup location="footer">
      {links.map(link => (
        <FooterLink key={link.label} link={link} bold={link.bold} />
      ))}
    </LinkGroup>
  );
};
